const practicePocTypes = [
  { value: "OFFICE_MANAGER", label: "Office manager" },
  { value: "EXECUTIVE", label: "Executive" },
  { value: "REVENUE_CYCLE", label: "Revenue cycle" },
  { value: "PHYSICIAN", label: "Physician" },
  { value: "REGIONAL", label: "Regional" },
  { value: "OTHER", label: "Other" },
];

export const getPracticePocTypeLabel = (value) => {
  const match = practicePocTypes.find((type) => type.value === value);
  return match ? match.label : value;
};

// Shapes the POCs for the practice update request (id is null for a new POC); drops fully blank rows
export const toPracticePocRequests = (pocs) => {
  return (pocs || [])
    .filter((poc) => poc.firstName || poc.lastName || poc.email || poc.phone)
    .map((poc) => ({
      id: poc.id == null ? null : poc.id,
      practicePocType: poc.practicePocType,
      firstName: poc.firstName,
      lastName: poc.lastName,
      email: poc.email,
      phone: poc.phone == null ? poc.phone : poc.phone.replace(/_/g, ""),
    }));
};

export default practicePocTypes;
